import { render, staticRenderFns } from "./TrackerSimplifiForm.vue?vue&type=template&id=480dedd8&"
import script from "./TrackerSimplifiForm.vue?vue&type=script&lang=js&"
export * from "./TrackerSimplifiForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports